import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/technicalcards',
    name: RouteName.TechnicalCards,
    component: () => import('@/pages/TechnicalCards/TechnicalCards'),
    meta: {
      breadcrumb: {
        label: 'Технические карты',
        parent: RouteName.Directory,
      },
    },
  },
  {
    path: '/technicalcards/create',
    name: 'technicalCardCreate',
    component: () => import('@/pages/TechnicalCards/TechnicalCardsCreate'),
    meta: {
      breadcrumb: {
        label: 'Новая техническая карта',
        parent: RouteName.TechnicalCards,
      },
    },
  },
  {
    path: '/technicalcards/:id',
    name: 'technicalCardEdit',
    component: () => import('@/pages/TechnicalCards/TechnicalCardsSingle'),
    props: { isEdit: false },
    meta: {
      breadcrumb: {
        label: 'Редактирование технической карты',
        parent: RouteName.TechnicalCards,
      },
    },
  },
]
